import React from 'react';
import styled from 'styled-components';

import { mediaQueryLaptopMin } from 'styles';

const Wrapper = styled(({ hideOnMobile, hideOnDesktop, ...props }) => (
  <div {...props} />
))`
  margin: 0 auto 16px;

  ${({ hideOnMobile }) => {
    if (hideOnMobile) {
      return `
        display: none;

        @media all and ${mediaQueryLaptopMin} {
          display: block;
        }
      `;
    }

    return '';
  }}

  ${({ hideOnDesktop }) => {
    if (hideOnDesktop) {
      return `
        display: block;

        @media all and ${mediaQueryLaptopMin} {
          display: none;
        }
      `;
    }

    return '';
  }}
`;

export default Wrapper;
